import {
  getTransactions,
  getTransactionIncomeType,
  getTransactionCashbox,
  addNewTransaction,
  updateTransaction,
  uploadFile,
  exportExcel,
  getTransactionIncomeCharts,
  // getPaymentInstallmentsOfContract,
} from '@/api/finance'

export default {
  FETCH_TRANSACTIONS({ commit }, query) {
    return new Promise((resolve, reject) => {
      getTransactions(query)
        .then(res => {
          commit('SET_TRANSACTIONS', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_TRANSACTION_INCOME_TYPE({ commit }, query) {
    return new Promise((resolve, reject) => {
      getTransactionIncomeType(query)
        .then(res => {
          commit('SET_TRANSACTION_INCOME_TYPE', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  FETCH_TRANSACTION_CASHBOX({ commit }, query) {
    return new Promise((resolve, reject) => {
      getTransactionCashbox(query)
        .then(res => {
          commit('SET_TRANSACTION_CASHBOX', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-unused-vars
  ADD_TRANSACTIONS({ commit }, data) {
    return new Promise((resolve, reject) => {
      addNewTransaction(data)
        .then(res => {
          // commit('SET_TRANSACTION', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line no-unused-vars
  UPDATE_TRANSACTIONS({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateTransaction(data)
        .then(res => {
          // commit('SET_TRANSACTION', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  UPLOAD_FILE(_, data) {
    return uploadFile(data)
  },

  EXPORT_EXCEL(_, data) {
    return exportExcel(data)
  },

  FETCH_TRANSACTION_INCOME_CHARTS({ commit }, params) {
    return new Promise((resolve, reject) => {
      getTransactionIncomeCharts(params)
        .then(res => {
          commit('SET_TRANSACTION_INCOME_CHARTS', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
